var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mb-2", attrs: { id: "content-wrapper" } },
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _vm.$slots["title"] || _vm.$slots["information"]
            ? _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _vm.$slots["title"]
                      ? _c(
                          "h2",
                          { staticClass: "page-title" },
                          [_vm._t("title")],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$slots["information"]
                      ? _c(
                          "p",
                          { staticClass: "page-information" },
                          [_vm._t("information")],
                          2
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots["content"]
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [_vm._t("content")],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "d-flex flex-column justify-content-end mt-4",
          attrs: { cols: "12" },
        },
        [
          _vm.$slots["navigation"]
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [_vm._t("navigation")],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }